import { render, staticRenderFns } from "./PopupModal.vue?vue&type=template&id=90287248&scoped=true&"
import script from "./PopupModal.vue?vue&type=script&lang=js&"
export * from "./PopupModal.vue?vue&type=script&lang=js&"
import style0 from "./PopupModal.vue?vue&type=style&index=0&id=90287248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90287248",
  null
  
)

export default component.exports